import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API } from '../../services/axios.service';
import ApiUrls from '../../helper/ApiUrls';


const initialState = {
    dataByPage: {},
    myAssistantsDataByPage: {},
    currentPage: 1,
    totalPages: 0,
    totalPageskForAssistants: 0,
    status: 'idle',
    error: '',

};





export const fetchMyAssistants = createAsyncThunk('chatbot/myassistants', async ({ page, limit, forceReload = false }, { getState }) => {
    const state = getState();
    // Check if data for the requested page is already in the state
    if (!forceReload && state.chatBots.myAssistantsDataByPage[page]) {
        return {
            page,
            data: state.chatBots.myAssistantsDataByPage[page]
        };
    }
    const response = await API.get(`${ApiUrls.BOT_MY_ASSISTANTS}?page=${page}&limit=${limit}`);
    // console.log("response", response)
    return {
        page,
        data: response.data.data.chatbots,
        totalPages: response.data.data.total_pages,
        totalChatbots: response.data.data.total_chatbots,
    };
})


export const fetchChatBots = createAsyncThunk(
    'chatbot',
    async ({ page, limit, forceReload = false }, { getState }) => {
        const state = getState();

        if (!forceReload && state.chatBots.dataByPage[page]) {
            return { page, data: state.chatBots.dataByPage[page] };
        }

        const response = await API.get(`${ApiUrls.BOT_RESOURCE}?page=${page}&limit=${limit}`);
        return {
            page,
            data: response.data.data.chatbots,
            totalPages: response.data.data.total_pages,
            totalChatbots: response.data.data.total_chatbots,
        };
    }
);



export const chatBotsSlice = createSlice({
    name: 'chatBots',
    initialState,
    reducers: {
        resetMyAssistants: (state) => {
            state.myAssistantsDataByPage = {};
        },
        removeBot: (state, action) => {
            const { key, id } = action.payload;
            if (state.myAssistantsDataByPage[key]) {
                state.myAssistantsDataByPage[key] = state.myAssistantsDataByPage[key].filter(bot => bot.id !== id);
            }
        },
        updateBotInfo: (state, action) => {
            const { page, botId, botInfo } = action.payload;

            const bots = state.myAssistantsDataByPage[page] || [];
            const updatedBots = bots?.map(bot => bot.id === botId ? { ...bot, ...botInfo } : bot);

            state.myAssistantsDataByPage = updatedBots;
        },
        prependMyAssistant: (state, action) => {
            const { page, data } = action.payload;

            if (!state.myAssistantsDataByPage[page]) {
                state.myAssistantsDataByPage[page] = [];
            }
            state.myAssistantsDataByPage[page].unshift(data)
        },
        prependExpert: (state, action) => {
            const { page, data } = action.payload;

            // Initialize the page array if it does not exist
            if (!state.dataByPage[page]) {
                state.dataByPage[page] = [];
            }

            // Check if the data already exists in the page array based on id
            const existingIndex = state.dataByPage[page].findIndex(bot => bot.id === data.id);

            // If the data does not exist, unshift it to the beginning of the array
            if (existingIndex === -1) {
                state.dataByPage[page].unshift(data);
            }
        },

    },
    extraReducers: {
        [fetchChatBots.pending]: (state) => {
            state.status = 'loading';
        },
        [fetchChatBots.fulfilled]: (state, action) => {
            state.status = 'succeeded';
            state.dataByPage[action.payload.page] = action.payload.data;
            if (action.payload.totalPages) {
                state.totalPages = action.payload.totalPages;
            }
        },
        [fetchChatBots.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        },
        //  for my assistants
        [fetchMyAssistants.pending]: (state) => {
            state.status = 'loading';
        },
        [fetchMyAssistants.fulfilled]: (state, action) => {
            state.status = 'succeeded';
            state.myAssistantsDataByPage[action.payload.page] = action.payload.data;
            if (action.payload.totalPages) {
                state.totalPageskForAssistants = action.payload.totalPages;
            }
        },
        [fetchMyAssistants.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        },
    },
});

// Action creators are generated for each case reducer function
export const { resetMyAssistants, removeBot, updateBotInfo, prependMyAssistant, prependExpert } = chatBotsSlice.actions;
export default chatBotsSlice.reducer;
